(function () {
  'use strict';
  var root = document.getElementById('nuf-bt-product');
  if (!root || root.getAttribute('data-nb-init')) return;
  root.setAttribute('data-nb-init', '1');

  /* Gallery */
  var heroImg = root.querySelector('#nb-hero-img');
  var thumbs = root.querySelectorAll('[data-nb-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      heroImg.src = t.getAttribute('data-src');
      heroImg.alt = t.getAttribute('data-alt');
      thumbs.forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
    });
  });

  /* Quantity */
  var qty = root.querySelector('#nb-qty');
  var stickyQty = root.querySelector('[data-nb-sticky-qty]');
  function clean() {
    var n = parseInt(qty.value, 10);
    if (!n || n < 1) n = 1;
    return n;
  }
  function sync() { if (stickyQty) stickyQty.textContent = String(clean()); }
  function set(n) { qty.value = Math.max(1, n); sync(); }
  root.querySelector('[data-nb-qty-minus]').addEventListener('click', function () { set(clean() - 1); });
  root.querySelector('[data-nb-qty-plus]').addEventListener('click', function () { set(clean() + 1); });
  qty.addEventListener('input', sync);
  qty.addEventListener('change', function () { set(clean()); });
  var form = root.querySelector('#nb-product-form');
  if (form) form.addEventListener('submit', function () { qty.value = clean(); });

  /* Sticky bar */
  var sticky = root.querySelector('[data-nb-sticky]');
  var purchase = root.querySelector('#nb-purchase');
  if (sticky && purchase && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.hidden = !(!e.isIntersecting && e.boundingClientRect.bottom < 0);
    }, { threshold: 0 }).observe(purchase);
  }

  /* Dialogs */
  var lastTrigger = null;
  root.querySelectorAll('[data-nb-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = document.getElementById(b.getAttribute('data-nb-open'));
      if (!d) return;
      lastTrigger = b;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    });
  });
  root.querySelectorAll('dialog.nb-modal').forEach(function (d) {
    function close() {
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
    }
    d.querySelectorAll('[data-nb-close]').forEach(function (c) { c.addEventListener('click', close); });
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('close', function () { if (lastTrigger) lastTrigger.focus(); });
  });

  /* Videos */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function load(v) {
    if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); }
  }
  root.querySelectorAll('[data-nb-video]').forEach(function (fig) {
    var v = fig.querySelector('video');
    var btn = fig.querySelector('.nb-vid__play');
    var err = fig.querySelector('.nb-vid__err');
    var lead = v.hasAttribute('data-lead');
    var attempted = false;
    function fail() { err.hidden = false; btn.hidden = true; v.controls = false; }
    v.addEventListener('play', function () { v.controls = true; btn.hidden = true; });
    v.addEventListener('error', fail);
    btn.addEventListener('click', function () {
      load(v);
      var p = v.play();
      if (p && p.catch) p.catch(fail);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e.isIntersecting) { v.pause(); }
        else if (e.intersectionRatio >= 0.4 && lead && !attempted && !reduce.matches) {
          attempted = true;
          load(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      }, { threshold: 0.4 }).observe(v);
    }
    reduce.addEventListener && reduce.addEventListener('change', function () { if (reduce.matches) v.pause(); });
  });
})();
